import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import AccessDenied from './AccessDenied';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
    WithStyles,
    createStyles,
    Grid,
    Typography,
} from '@material-ui/core';

interface MyPATAccessDeniedProps {   
}

interface MyPATAccessDeniedState {
}
const styles = (theme: Theme) => createStyles({
})

class MyPATAccessDenied extends Component<MyPATAccessDeniedProps, MyPATAccessDeniedState> {
    slickRef=undefined
    constructor(props: MyPATAccessDeniedProps, state: MyPATAccessDeniedState) {
        super(props);
    }
     
    render() {

        return (
            <AccessDenied 
            imageURL="/assets/svg/access-denied.svg"
            heading="Access Denied!"
            subPara="You don’t have access to this content.  You can request for the access from your supervisor."
           /> 
        );
    }
};

// @ts-ignore 
export default withStyles(styles)(MyPATAccessDenied);